import { Color } from '../../color.model';

export const brown: Color = {
  light: {
    1: 'hsl(30, 40.0%, 99.1%)',
    2: 'hsl(30, 50.0%, 97.6%)',
    3: 'hsl(30, 52.5%, 94.6%)',
    4: 'hsl(30, 53.0%, 91.2%)',
    5: 'hsl(29, 52.9%, 86.8%)',
    6: 'hsl(29, 52.5%, 80.9%)',
    7: 'hsl(29, 51.5%, 72.8%)',
    8: 'hsl(28, 50.0%, 63.1%)',
    9: 'hsl(28, 34.0%, 51.0%)',
    10: 'hsl(27, 31.8%, 47.6%)',
    11: 'hsl(25, 30.0%, 41.0%)',
    12: 'hsl(20, 30.0%, 19.0%)',
  },
  dark: {
    1: 'hsl(22, 15.0%, 8.7%)',
    2: 'hsl(20, 28.3%, 10.4%)',
    3: 'hsl(20, 28.0%, 14.0%)',
    4: 'hsl(21, 28.4%, 16.5%)',
    5: 'hsl(22, 28.7%, 18.9%)',
    6: 'hsl(23, 29.0%, 22.3%)',
    7: 'hsl(25, 29.5%, 27.8%)',
    8: 'hsl(27, 30.1%, 35.9%)',
    9: 'hsl(28, 34.0%, 51.0%)',
    10: 'hsl(28, 41.4%, 55.8%)',
    11: 'hsl(28, 60.0%, 64.5%)',
    12: 'hsl(30, 67.0%, 94.0%)',
  },
};
